import img1 from "../../../assets/images/industry/1.png";
import icon1 from "../../../assets/images/industry/icons/1.png";
import img2 from "../../../assets/images/industry/2.png";
import icon2 from "../../../assets/images/industry/icons/2.png";
import img3 from "../../../assets/images/industry/3.png";
import icon3 from "../../../assets/images/industry/icons/3.png";
import img4 from "../../../assets/images/industry/4.png";
import icon4 from "../../../assets/images/industry/icons/4.png";
import img5 from "../../../assets/images/industry/5.png";
import icon5 from "../../../assets/images/industry/icons/5.png";
import img6 from "../../../assets/images/industry/6.png";
import icon6 from "../../../assets/images/industry/icons/6.png";
import img7 from "../../../assets/images/industry/7.png";
import icon7 from "../../../assets/images/industry/icons/7.png";
import img8 from "../../../assets/images/industry/8.png";
import icon8 from "../../../assets/images/industry/icons/8.png";
import img9 from "../../../assets/images/industry/9.png";
import icon9 from "../../../assets/images/industry/icons/9.png";
import img10 from "../../../assets/images/industry/10.png";
import icon10 from "../../../assets/images/industry/icons/10.png";

// ... continue to img10, icon10

const industryData = [
  {
    title: "Banking",
    description: "Streamline operations with smart document processing",
    features: ["KYC Automation", "Document Verification", "Fraud detection"],
    img: img1,
    icon: icon1,
  },
  {
    title: "Insurance",
    description: "Automate claims processing and risk assessment",
    features: ["Claims Processing", "Policy Management", "Risk Analysis"],
    img: img2,
    icon: icon2,
  },
  {
    title: "HealthCare",
    description: "Transform patient care with AI-powered solutions",
    features: [
      "Medical Records Processing",
      "Insurance Verification",
      "Patient Data Management",
    ],
    img: img3,
    icon: icon3,
  },
  {
    title: "Fintech",
    description: "Power financial innovation with cognitive computing",
    features: [
      "Payment Processing",
      "Identity Verification",
      "Transaction Analysis",
    ],
    img: img4,
    icon: icon4,
  },
  {
    title: "Crypto",
    description: "Secure and efficient crypto transaction processing",
    features: [
      "KYC/AML Compliance",
      "Transaction Verification",
      "Wallet Management",
    ],
    img: img5,
    icon: icon5,
  },
  {
    title: "Legal",
    description: "Automate legal document processing and analysis",
    features: ["Contract Analysis", "Document Review", "Case Management"],
    img: img6,
    icon: icon6,
  },
  {
    title: "Logistics",
    description: "Optimize supply chain operations with AI",
    features: [
      "Shipping Documentation",
      "Invoice Processing",
      "Inventory Management",
    ],
    img: img7,
    icon: icon7,
  },
  {
    title: "Maritime",
    description: "Streamline maritime operations and documentation",
    features: ["Bill of Landing", "Custom Documentation", "Cargo Tracking"],
    img: img8,
    icon: icon8,
  },
  {
    title: "Aviation",
    description: "Enhance aviation operations with intelligent processing",
    features: [
      "Flight Documentation",
      "Maintenance Record ",
      "Crew Management",
    ],
    img: img9,
    icon: icon9,
  },
  {
    title: "Gaming",
    description: "Power gaming platforms with AI verification",
    features: [
      "Player Verification",
      "Payment Processing ",
      "Fraud Prevention",
    ],
    img: img10,
    icon: icon10,
  },
];

export default industryData;
